<template>
  <main id="mf">
    <div class="loadingMask" :class="{ open: MfLoadingMask }"></div>
    <TabHeader
      :TabList="TabList"
      :currentTab="currentTab"
      v-show="!hiddenTab"
    ></TabHeader>
    <div class="tab-content">
      <!-- <a class="btn btn-default m-0" style="line-height: 30px; height: 50px">
      列出所有客戶
    </a> -->
      <router-view v-if="ready"></router-view>
      <MfNotice></MfNotice>
      <div class="backToTop" @click="backToTop()">
        <img src="./assets/backtotop.png" alt="" />
        <div>TOP</div>
      </div>
    </div>
  </main>
</template>

<script>
import Vue from "vue";
import API from "@/desktop/views/mf/API/api.js";
import TabHeader from "@/desktop/views/mf/components/TabHeader.vue";
import MfNotice from "@/desktop/views/mf/components/MfNotice.vue";
//api
import { getFamilyMemberByCsidNo } from "@/service";
// import queryParagrpnoMapMock from "@/desktop/views/mf/mock/queryParagrpnoMap.json";
// import queryParamDetailListMock from "@/desktop/views/mf/mock/queryParamDetailList.json";
export default {
  components: { TabHeader, MfNotice },
  data() {
    return {
      TabList: [
        {
          name: "新增/輸入",
          URL: `/mf/create`,
          tabClassify: "create",
          authority: "1,2", //權限卡控(1國壽2保代)
          directMarketingUser: true,
        },
        {
          name: "查詢/列印",
          URL: `/mf/query`,
          tabClassify: "query",
          authority: "1,2",
          directMarketingUser: true,
        },
        {
          name: "我的收藏組合",
          URL: `/mf/compose`,
          tabClassify: "compose",
          authority: "1,2",
          directMarketingUser: true,
        },
      ],
      ready: false,
      // MXF1 iframe 必須等 MF 參數初始化且 listener 完成註冊後，才能進行握手。
      mxf1IframeMounted: false,
      mxf1IframeReadyNotified: false,
    };
  },
  async created() {
    //請改IP >>local測試用
    if (
      window.location.href.indexOf("localhost") !== -1 ||
      window.location.href.indexOf(process.env.VUE_APP_DEV_IP) !== -1
    ) {
      let UserInfo = this.$store.getters.UserInfo;
      this.$store.dispatch("updateUserInfo", {
        data: {
          ...UserInfo,
          divNo: "9400400",
          id: "Q15487199P",
        },
      });
      if (window.AJADev) {
        //本機模式
        this.$store.commit("set_user_channel_type", {
          compId: "A0",
          divFullName: "通路資訊科",
          divShortName: "通路資訊科",
        });
      }
    } else {
      let userInfo = this.$store.state.userInfo;
      this.$store.commit("set_user_channel_type", userInfo);
    }
    Vue.prototype.$mfAPI = API;
    //參數
    let { paragrpno } = await API.MFB0_9100__queryParagrpnoMap({
      paragrpno: [
        "gender_ind",
        "period_type",
        "pay_freq",
        "pay_dis",
        "group_dis",
        "amt_unit",
        "chapter",
        "chapter_inv",
        "chapter_iul",
        "add_method",
        "cover_type",
        "curr",
        "special_array",
        "anty_pay",
        "access_privileges",
        "prod_white_list",
        "bou_type_opt_ind",
        "inv_dist_type",
        "close_oldinv",
        "div_type",
        "level_nm",
        "dvd_kind",
      ],
    });
    //單位對應價值
    let { paramDetailList } = await API.MFB0_9100__queryParamDetailList({
      paragrpno: "amt_unit",
    });
    // let { paragrpno } = queryParagrpnoMapMock;
    // let { paramDetailList } = queryParamDetailListMock;

    //查找access_privileges
    Vue.prototype.$access_privileges = (name) => {
      let value = paragrpno.access_privileges.find((item) => {
        return item.paraval == name;
      });
      return value ? value.paradetlno : "";
    };
    //查找白名單商品
    Vue.prototype.$prod_white_list = (prod_id) => {
      let value = paragrpno.prod_white_list.find((item) => {
        return item.paraval == prod_id;
      });
      return value ? value.paradetlno : "";
    };
    //試點模式在是否開啟>>後台參數bu_test==1時
    this.$store.commit("set_bu_test", this.$access_privileges("bu_test"));
    //[改版建議書]-關閉舊建議書投資型的開關>>後台參數close_oldinv
    this.$store.commit(
      "set_close_oldinv",
      this.$access_privileges("close_oldinv")
    );
    //投資型匯入行動投保是否開啟>>後台參數is_inv_mi==1時
    this.$store.commit("set_is_inv_mi", this.$access_privileges("is_inv_mi"));
    //是否關閉回舊建議書按鈕>>後台參數close_allt==1時
    this.$store.commit("set_close_all", this.$access_privileges("close_all"));
    //是否為測試人員(it和bu單位)
    this.$store.commit("set_isMfTesters", {
      ...this.$store.getters.UserInfo,
      front_access: this.$access_privileges("front_access"),
    });
    //查找special_array
    Vue.prototype.$special_array = (name) => {
      let target = paragrpno.special_array.find((item) => {
        return item.paraval == name;
      });
      return target.paradetlno.split(",");
    };
    Vue.prototype.$amtUnitFormat = (amt_unit) => {
      let value = paramDetailList.find((item) => {
        return item.paraval == amt_unit;
      }).desc;
      if (!value) console.log("找不到", amt_unit, paramDetailList);
      return parseInt(value);
    };
    Vue.prototype.$amtUnitToNm = (amt_unit) => {
      let unitData = paragrpno.amt_unit.find((item) => {
        return item.paraval == amt_unit;
      });
      return unitData ? unitData.paradetlno : "";
    };
    Vue.prototype.$paragrpno = paragrpno;
    //產生唯一key
    Vue.prototype.$uniqueKey = () => {
      return Number(
        Math.random()
          .toString()
          .substr(3, 5) + Date.now()
      ).toString(36);
    };
    this.ready = true;
    // MF 初始化完成後通知新版 MXF1，母頁才會回傳目前選取的客戶。
    this.notifyMxf1IframeReady();
  },
  computed: {
    isMxf1() {
      // 只有由指定 MXF1 網域嵌入時才啟用跨頁同步。
      const parentOrigin = this.getMxf1ParentOrigin();
      const isMxf1Host = /^https:\/\/(tagpaas|sagpaas|agpaas)\.cathaylife\.com\.tw$/.test(
        parentOrigin
      );

      return isMxf1Host;
    },
    currentTab() {
      let tabClassify = this.$route.meta.tabClassify;
      let current = this.TabList.find((item) => {
        return item.tabClassify == tabClassify;
      });
      return current ? current.name : "新增建議書";
    },
    MfLoadingMask() {
      return this.$store.getters.MfLoadingMask;
    },
    hiddenTab() {
      return (
        this.$route.name == "addPayment" ||
        this.$route.name == "paymentPreview" ||
        this.$route.name == "investmentTarget" ||
        this.$route.name == "AddPremium" ||
        this.$route.name == "PremiumPreview" ||
        this.$route.name == "AddPayment2" ||
        this.$route.name == "PaymentPreview2" ||
        this.$route.name == "AddPayment3" ||
        this.$route.name == "PaymentPreview3" ||
        this.$route.name == "createDetailPaymentPreview"
      );
    },
  },
  methods: {
    getMxf1ParentOrigin() {
      if (!document.referrer) return "";

      try {
        return new URL(document.referrer).origin;
      } catch (error) {
        return "";
      }
    },
    notifyMxf1IframeReady() {
      // 避免在 created/mounted 的不同時序重複通知，或在 iframe 尚未就緒時通知母頁。
      if (
        !this.isMxf1 ||
        !this.ready ||
        !this.mxf1IframeMounted ||
        this.mxf1IframeReadyNotified
      )
        return;

      const parentOrigin = this.getMxf1ParentOrigin();
      if (!parentOrigin) return;

      window.parent.postMessage({ type: "IFRAME_READY" }, parentOrigin);
      this.mxf1IframeReadyNotified = true;
    },
    syncMxf1Customer(csid) {
      // CRMVUE 以「~」開頭的 csid 表示無身分證客戶，需存入 serNo 而非 CustID。
      const isSerNo = csid.startsWith("~");
      const custId = isSerNo ? "" : csid;
      const serNo = isSerNo ? csid : "";

      this.$store.dispatch("updateCustID", custId);
      this.$store.dispatch("updateSerNo", serNo);
      localStorage.CustID = custId;
      localStorage.SerNo = serNo;
    },
    async importMember(targetId) {
      // MXF1 傳入客戶與既有 detail 進入 MF 共用同一套家戶初始化流程。
      const { data } = await getFamilyMemberByCsidNo(
        this.$store.getters.UserInfo.id,
        targetId
      );
      data.forEach((item) => {
        item.insured_name = item.name;
        item.insured_id = item.csidno;
        item.insured_gender = item.sex;
        item.insured_birthday =
          !item.birthday || item.birthday === ""
            ? ""
            : moment(item.birthday + "").format("YYYY-MM-DD");
        item.insured_age = item.age + "";
        item.job_cat = "";
        item.check = true;
      });
      this.getKycAPI(data);
      if (!data[0]) return console.log("家戶沒人");
      data.sort((a, b) => {
        return a.familyrl - b.familyrl;
      });
      this.$store.commit("set_MemberList", data);
      const targetPeople = data.find((item) => item.insured_id == targetId);
      this.$store.commit("update_MfEditing", {
        inputType: "family",
        insured: _.cloneDeep(targetPeople),
        insurer: _.cloneDeep(targetPeople),
        sameInsurer: false,
      });
      this.$store.commit("update_queryDetailTarget", {
        is_crm: "1",
        insured_id: targetPeople.familyid,
        prod_idx: "",
        familyid: targetPeople.familyid,
      });
    },
    handlePostMessage(event) {
      // 只接受直接來自新版 MXF1 父視窗的訊息，避免其他視窗觸發客戶切換。
      if (
        !this.isMxf1 ||
        event.source !== window.parent ||
        event.origin !== this.getMxf1ParentOrigin()
      ) {
        return;
      }

      const { type, csid } = event.data || {};
      // MXF1 母頁以 Base64 傳送 csid，解碼失敗時忽略訊息並維持目前畫面。
      if (type !== "SET_CSID" || !csid) return;

      let decryptedCsid = "";
      try {
        decryptedCsid = atob(csid);
      } catch (error) {
        return;
      }
      if (!decryptedCsid) return;

      // MXF1 以母頁傳入的客戶為準，不使用 iframe 內可能殘留的舊客戶資料。
      this.$store.commit("reset_Customer");
      this.syncMxf1Customer(decryptedCsid);
      this.importMember(decryptedCsid).catch(() => {});
    },
    backToTop() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    },
    getKycAPI(MemberList) {
      let APC_IDList = [];
      MemberList.filter((item) => {
        let obj = {
          APC_ID: item.csidno,
          BRDY: item.birthday,
        };
        APC_IDList.push(obj);
      });
      this.$store.commit("set_allRiskObj", ""); //舊有家戶 riskObj 清空
      this.$mfAPI
        .MFA1_0100__getKYCInfo({
          APC_IDs: APC_IDList,
        })
        .then((res) => {
          this.$store.commit("set_allRiskObj", res);
        })
        .catch((error) => {
          this.$toast.info({
            title: "風險屬性檢核異常，您可以稍後再重新確認",
          });
        });
    },
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.$store.commit("reset_Customer");
      //需要預帶資料
      if (
        !vm.isMxf1 &&
        ((vm.$store.getters.CustInfo.ID && localStorage.CustID) ||
          (localStorage.SerNo && vm.$store.getters.CustInfo.serNo))
      ) {
        //來源為CRM客戶資訊頁面
        if (from.path.includes("detail")) {
          vm.importMember(localStorage.CustID || localStorage.SerNo);
        }
        // 來源為保單健檢
        if (from.fullPath.indexOf("/mv/") > -1 && localStorage.userItems) {
          let familyLeader = JSON.parse(localStorage.userItems);
          setTimeout(() => {
            vm.$mfNotice(
              `請問您是否要繼續使用「${familyLeader.name}」的家戶?`,
              () => {
                vm.importMember(familyLeader.csidno);
              },
              true,
              () => {},
              "確定",
              "",
              "",
              "不繼續使用"
            );
          }, 500);
        }
      }
    });
  },
  mounted() {
    if (this.isMxf1) {
      // 先註冊 listener，再送出 IFRAME_READY，避免母頁回傳 SET_CSID 時遺失訊息。
      window.addEventListener("message", this.handlePostMessage);
      this.mxf1IframeMounted = true;
      this.notifyMxf1IframeReady();
    }
  },
  beforeDestroy() {
    this.mxf1IframeMounted = false;
    if (this.isMxf1) {
      // MF Index 可能因離開建議書而重新建立，離開時移除 listener 避免重複處理。
      window.removeEventListener("message", this.handlePostMessage);
    }
  },
};
</script>

<style lang="scss">
@import "./scss/mf.scss";
#mf {
  min-height: 101vh;
  background-color: #fff;
  -webkit-text-size-adjust: none;
  -moz-text-size-adjust: none;
  -ms-text-size-adjust: none;
  text-size-adjust: none;
  word-break: break-all;
  @include unity;
  @include other;
  .tooltip-text {
    z-index: 9999;
  }
  .create_title {
    color: #606060;
    font-weight: 700;
  }
  .backToTop {
    position: fixed;
    right: 2vw;
    bottom: 110px;
    width: 50px;
    height: 50px;
    border: solid 2px #53c480;
    background-color: #fff;
    border-radius: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    z-index: 1040;
    img {
      width: 24px;
    }
    line-height: 1.38;
    color: #027a39;
  }
  .container.mf_container {
    @media (min-width: 1025px) {
      width: 1280px !important;
      max-width: 1280px;
    }
  }
  .loadingMask {
    background-color: rgba(0, 0, 0, 0);
    position: fixed;
    width: 100vw;
    height: 100vh;
    z-index: 9999999;
    display: none;
    &.open {
      display: flex;
    }
  }

  input[type="number"]::-webkit-outer-spin-button,
  input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  .radio input:disabled:not(:checked) + label:after {
    visibility: hidden;
  }
  //用mf自己的紅色叉叉圖片
  .form-control.is-invalid {
    background-image: url("./assets/icon-close-red.svg");
    background-size: 20px 20px;
    background-position: center right 8px !important;
    background-repeat: no-repeat;
    padding-right: 2rem !important;
  }
  .vdp-datepicker.is-invalid input {
    background-image: url("./assets/icon-close-red.svg");
    background-size: 20px 20px;
    background-position: center right 8px;
    background-repeat: no-repeat;
    border-color: red;
  }
  .waring-text {
    position: absolute;
    top: 44px;
    left: 4px;
    font-size: 13px;
    font-weight: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #de4054;
  }
  .clearPosition {
    position: absolute;
    right: 10px;
    top: 12px;
    z-index: 22;
  }
  .clearBirthday {
    position: absolute;
    right: 10px;
    top: 42px;
    z-index: 22;
    font-size: 13px;
    text-decoration: underline;
    cursor: pointer;
  }
  .was-validated select.form-control:invalid,
  select.form-control.is-invalid {
    padding-right: 1.8rem !important;
  }
  .mf-textWrap {
    white-space: normal !important;
  }
  .mf-textNoWrap {
    white-space: nowrap !important;
  }
}
</style>
